import _ from 'lodash';
import {
  createReducer,
  createPostActionForNamespace,
  createFetchReducersWithPagination,
  createFetchSelectors,
  createFetchPaginatedActionForNamespace
} from 'utils/reducers';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {transformPaginationForStoreToPaginationForApi} from 'utils/pagination';
import {selectPagination, PAGINATION} from 'ducks/pagination';
import {selectFilters, FILTERS} from 'ducks/filters';

const createPostAction = createPostActionForNamespace('users/list');
const createFetchPaginatedAction = createFetchPaginatedActionForNamespace(
  'users/list'
);

export const fetchUsers = createFetchPaginatedAction({
  name: 'FETCH_USERS',
  initialAction: () => ({payload: {extraActions: []}}),
  stateKey: 'users',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.USERS_LIST)
      ),
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.USERS_LIST)
      )
  ],
  paginationNamespace: PAGINATION.USERS_LIST
});
const usersSelector = createFetchSelectors(fetchUsers);
export const selectUsers = usersSelector.data;
export const selectUsersLoading = usersSelector.isLoading;

export const promoteToMember = createPostAction({
  name: 'PROMOTE_TO_MEMBER',
  initialAction: ({userId}, extraActions = []) => ({
    payload: {userId, extraActions}
  })
});

export const demoteMember = createPostAction({
  name: 'DEMOTE_MEMBER',
  initialAction: ({memberId}, extraActions = []) => ({
    payload: {memberId, extraActions}
  })
});

export const createMember = createPostAction({
  name: 'CREATE_MEMBER',
  initialAction: ({email, fullName}, extraActions = []) => ({
    payload: {email, fullName, extraActions}
  }),
  formName: 'createMember'
});

export const createUser = createPostAction({
  name: 'CREATE_USER',
  initialAction: ({email, fullName}, extraActions = []) => ({
    payload: {email, fullName, extraActions}
  }),
  formName: 'createUser'
});

export const updateUser = createPostAction({
  name: 'UPDATE_USER',
  initialAction: (
    {
      fullName,
      email,
      knownAs,
      phone,
      age,
      gender,
      birthday,
      nationality,
      newJoiner,
      bio,
      userId
    },
    extraActions = []
  ) => ({
    payload: {
      fullName,
      email,
      knownAs,
      phone,
      age,
      gender,
      birthday,
      nationality,
      newJoiner,
      bio,
      userId,
      extraActions
    }
  }),
  formName: 'updateUser'
});

export const verifyUserInternalAvatarUpload = createPostAction({
  name: 'VERIFY_USER_INTERNAL_AVATAR_UPLOAD',
  initialAction: ({userId, identifier}, extraActions = []) => ({
    payload: {userId, identifier, extraActions}
  })
});

export const fetchMembersForDashboard = createFetchPaginatedAction({
  name: 'FETCH_MEMBERS_FOR_DASHBOARD',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {locationRef, extraActions}
  }),
  stateKey: 'members',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.MEMBER_LIST)
      ),
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.MEMBER_LIST)
      )
  ],
  paginationNamespace: PAGINATION.MEMBER_LIST
});
const membersSelector = createFetchSelectors(fetchMembersForDashboard);
export const selectMembers = membersSelector.data;
export const selectMembersLoading = membersSelector.isLoading;

export const MODALS = {
  USER_DETAIL: 'userDetail',
  CREATE_MEMBER: 'createMember',
  CREATE_USER: 'createUser'
};

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducersWithPagination(fetchUsers),
  ...createFetchReducersWithPagination(fetchMembersForDashboard)
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;
export {default as userListSaga} from './saga';
